import { useMutation, useQuery } from "react-query";
import { PageFilter, Count, ServerError, NameAndId } from "../../data";
import { TransactionType, WalletType } from "../../enums";
import { getCaptchaToken, useAxios } from "../../hooks";

export const useGetBillPayments = (params: PageFilter) => {
  const axios = useAxios();
  return useQuery<Count<BillPaymentDto>, ServerError>({
    queryKey: ["bill-paymnets", params],
    keepPreviousData: true,

    initialData: { total: 0, items: [] },
    queryFn: () =>
      axios.get("/utilities/api", {
        params,
      }),
  });
};
////Airtime
export const useGetAirtimeCountries = () => {
  const axios = useAxios();
  return useQuery<NameAndId[], ServerError>({
    queryKey: ["airtime-countries"],
    keepPreviousData: true,
    initialData: [],
    queryFn: () => axios.get("/utilities/api/airtimes-countries", {}),
  });
};

export const useGetAirtimes = (params: AirtimeFilter) => {
  const axios = useAxios();
  return useQuery<Count<AritimeData>, ServerError>({
    queryKey: ["airtimes", params],
    keepPreviousData: true,
    enabled: !!params.countryCode,
    queryFn: () => axios.get("/utilities/api/airtimes", { params }),
  });
};
export const useGetAirtimeById = () => {
  const axios = useAxios();
  return useMutation<AritimeData, ServerError, any>((airtimeId) => {
    return axios.get(`/utilities/api/airtimes/${airtimeId}`);
  });
};
export const useBuyAirtime = () => {
  var axios = useAxios();
  return useMutation<BuyAirtimeResult, ServerError, PayAirtimeBillModel>(async (model) => {
    return axios.post(`/utilities/api/airtimes`, model, {
      headers: { Captcha: await getCaptchaToken() },
    });
  });
};

////

export const useGetBillCountries = () => {
  const axios = useAxios();
  return useQuery<NameAndId[], ServerError>({
    queryKey: ["bill-countries"],
    keepPreviousData: true,
    initialData: [],
    queryFn: () => axios.get("/utilities/api/bills-countries", {}),
  });
};
export const useGetBillCategories = (countryCode, onSuccess: (data: BillCategoryData[]) => void) => {
  const axios = useAxios();
  return useQuery<BillCategoryData[], ServerError>({
    queryKey: ["bill-categories", { countryCode }],
    keepPreviousData: true,
    initialData: [],
    retry: false,
    queryFn: () => axios.get("/utilities/api/categories", { params: { countryCode } }),
    onSuccess: onSuccess,
  });
};
export type BillerFilter = {
  categoryId: any;
  search: string;
  countryCode: string;
} & PageFilter;
export const useGetBillers = (params: BillerFilter) => {
  const axios = useAxios();
  return useQuery<Count<BillerData>, ServerError>({
    queryKey: ["billers", params],
    queryFn: () =>
      axios.get("/utilities/api/billers", {
        params,
      }),
  });
};
export const useGetPackages = (billerId) => {
  const axios = useAxios();
  return useMutation<PackageHouseData, ServerError, any>((any) => {
    return axios.get("/utilities/api/packages", { params: { billerId } });
  });
};
export const usePayBill = () => {
  var axios = useAxios();
  return useMutation<BuyAirtimeResult, ServerError, PayAirtimeBillModel>(async (model) => {
    return axios.post(`/utilities/api/bills`, model, { headers: { Captcha: await getCaptchaToken() } });
  });
};
export interface ComputeAmountModel {
  amount?: any;
  packageId?: string;
  billTypeId?: TransactionType;
}
export const useComputeAmount = () => {
  var axios = useAxios(false);
  return useMutation<CalculateAmountResult, ServerError, ComputeAmountModel>(async (model) => {
    return axios.post(`/utilities/api/compute-amount`, model, {});
  });
};

export interface BillerData {
  categoryName: string;
  billerId: string;
  name: string;
  logoUrl: string;
  surcharge: number;
  shortName: string;
  customerField: string;
  currency: string;
  currencySymbol: string;
  exchangeRate: number;
  countries: string;
}
export interface PackageHouseData {
  packages: PackageData[];
  categoryName: string;
  billerId: string;
  name: string;
  logoUrl: string;
  surcharge: number;
  shortName: string;
  customerField: string;
  currency: string;
  currencySymbol: string;
  countries: string;
}

export interface PackageData {
  packageId: string;
  name: string;
  amount: number;
  consumerIdField: string;
}

export interface BillCategoryData {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  providerType: string;
  providerTypeId: number;
}
export interface AirtimeFilter extends PageFilter {
  countryCode: string;
  search: string;
}
export interface BuyAirtimeResult {
  orderStatus: string;
  statusId: number;
}

export interface AritimeData {
  currency: string;
  currencySymbol: string;
  airtimeId: string;
  name: string;
  logoUrl: string;
  description: string;
  amount: string;
  countries: string;
}

export interface Country {
  code: string;
  name: string;
}
export interface PaymnetBaseModel {
  paymentMethodId: WalletType;
  pin: string;
  voucherCode: string;
  amount: string;
}

export interface PayAirtimeBillModel {
  amount: string;
  customerId: string;
  packageId?: string;
  paymentMethodId: WalletType;
  voucherCode: string;
  pin: string;
  billTypeId: TransactionType;
  groupId?: string;
  quantity: number;
}

export interface CalculateAmountResult {
  subTotal: number;
  amountPayable: number;
  fee: number;
}
export interface BillPaymentDto {
  id: number;
  billName: string;
  narration: string;
  firstName: string;
  lastName: string;
  billTypeId: number;
  billType: string;
  statusId: number;
  status: string;
  subTotal: string;
  amountPerUnit: string;
  dateCreated: string;
  quantity: number;
  paymnetMethodId: number;
  paymentMethod: string;
  companyName: string;
  unitName: string;
}
